<template>
  <layout-default-appbar>
    Sincronizar
  </layout-default-appbar>
</template>

<script>

import LayoutDefaultAppbar from '@/layouts/default/AppBar.vue';

export default {
  name: 'ViewSincronizarAppBar',

  components: {
    LayoutDefaultAppbar,
  },

  data() {
    return {
    };
  },
};
</script>
